<app-page-header
  [title]="'Clubes'"
  [subtitle]="'Módulo de visualización de vinculaciones por club'"
></app-page-header>
<p-toast></p-toast>
<div class="card flex justify-content-center m-2">
  <div>
    <p-autoComplete
      [(ngModel)]="clubSelected"
      [dropdown]="true"
      [suggestions]="suggestions"
      (completeMethod)="filterClub($event)"
      (onSelect)="onSelectClub()"
      field="displayName"
      placeholder="Buscar club"
    />
  </div>
</div>

<div class="card" *ngIf="showMembersTable">
  <p-table
    #dt1
    [value]="members"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} registros"
    [globalFilterFields]="[
      'idNumber',
      'name',
      'lastName',
      'gender',
      'modalidad',
      'nivel',
      'isActivo',
      'contactInformation.email',
      'contactInformation.mobile'
    ]"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
  >
    <ng-template pTemplate="caption">
      <button
      type="button"
      pButton
      pRipple
      rounded
      icon="pi pi-info"
      (click)="showClubInfo = !showClubInfo"
      class="p-button-info mr-1"
      pTooltip="Información del Club"
      tooltipPosition="bottom"
    ></button>

      <button
        type="button"
        pButton
        pRipple
        rounded
        icon="pi pi-file-excel"
        (click)="exportExcel()"
        class="p-button-primary mr-1"
        pTooltip="Exportar Excel"
        tooltipPosition="bottom"
      ></button>

      <button
        pButton
        label="Limpiar Filtros"
        class="p-button-outlined"
        icon="pi pi-filter-slash"
        (click)="clear(dt1)"
      ></button>
      <span class="p-input-icon-left ml-auto">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Búsqueda por palabras"
        />
      </span>

    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Modalidad
            <p-columnFilter
              type="text"
              field="modalidad"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Rol
            <p-columnFilter
              type="text"
              field="rol"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Id
            <p-columnFilter
              type="text"
              field="idNumber"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Nombres
            <p-columnFilter
              type="text"
              field="name"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Apellidos
            <p-columnFilter
              type="text"
              field="lastName"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>

        <th style="min-width: 5rem">
          <div class="flex align-items-center">
            Género
            <p-columnFilter
              type="text"
              field="gender"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 5rem">
          <div class="flex align-items-center">
            Edad
            <p-columnFilter
              type="text"
              field="birthday"
              display="menu"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Fecha Vinculación
            <p-columnFilter
              type="text"
              field="auditData.createdDate"
              display="fechaVinculacion"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">
            Estado
            <p-columnFilter
              type="text"
              field="isActive"
              display="isActive"
            ></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 1rem">
          <div class="flex align-items-center">Acciones</div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-member let-columns="columns">
      <tr>
        <td>
          <span class="p-column-title font-bold">Modalidad</span>
          {{ member.modalidad }}
        </td>
        <td>
          <span class="p-column-title font-bold">Rol</span>
          {{ member.rol }}
        </td>
        <td>
          <span class="p-column-title font-bold">Id</span>
          {{ member.idType }} {{ member.idNumber }}
        </td>
        <td>
          <span class="p-column-title font-bold">Nombres</span>
          <span class="ml-1 vertical-align-middle">{{ member.name }}</span>
        </td>
        <td>
          <span class="p-column-title font-bold">Apellidos</span>
          <span class="ml-1 vertical-align-middle">{{ member.lastName }}</span>
        </td>
        <td>
          <span class="p-column-title font-bold">Género</span>
          <span class="ml-1 vertical-align-middle">{{
            getMemberGenere(member.gender)
          }}</span>
        </td>
        <td>
          <span class="p-column-title font-bold">Edad</span>
          <span class="ml-1 vertical-align-middle"
            >{{ calculateYearsOld(member.birthDay) }} Años</span
          >
        </td>
        <td>
          <span class="p-column-title font-bold">Fecha Vinculación</span>
          {{ member.auditData.createdDate | date : "dd-MM-yyyy" }}
        </td>
        <td>
          <span class="p-column-title font-bold">Estado</span>
          {{ member.isActive ? "Activo" : "Inactivo" }}
        </td>
        <td>
          <p-button
            icon="pi pi-user"
            [rounded]="true"
            [text]="true"
            [raised]="true"
            severity="primary "
            class="table__button"
            pTooltip="Ver Detalle"
            tooltipPosition="bottom"
            (onClick)="editMember(member)"
          />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">No se encontraron alumnos.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div *ngIf="showMemberDetail">
  <p-dialog
    [header]="memeberSelected!.name + ' ' + memeberSelected!.lastName"
    [(visible)]="showMemberDetail"
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '90vw', height: '80vh', top: '1.5rem' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="true"
    (onHide)="closeDialog()"
    [maximizable]="true"
  >
    <app-member-information
      [member]="memeberSelected!"
      (memberUpdated)="updateMember($event)"
      (memberDeleted)="handleMemberDeletion($event)"
    ></app-member-information>
  </p-dialog>
</div>
<div *ngIf="showClubInfo">
  <p-dialog [header]="clubSelected.displayName"  [modal]="true" [(visible)]="showClubInfo" [style]="{ width: '30rem' }">
    <span class="p-text-secondary block mb-5">Información del Club.</span>
    
    <!-- Modo visualización -->
    <div *ngIf="!isEditingClub">
      <div class="flex align-items-center gap-3 mb-3">
          <label class="font-semibold w-6rem">Email</label>
          <span class="flex-auto">{{clubSelected.contactInformation.email || 'No Registra'}}</span>
      </div>
      <div class="flex align-items-center gap-3 mb-5">
          <label class="font-semibold w-6rem">Teléfono</label>
          <span class="flex-auto">{{clubSelected.contactInformation.telephone || 'No Registra'}}</span>
      </div>
      <div class="flex align-items-center gap-3 mb-5">
        <label class="font-semibold w-6rem">Representante</label>
        <span class="flex-auto">{{clubSelected.administrativeInformation.leagalPrincipal || 'No Registra'}}</span>
      </div>
      <div class="flex align-items-center gap-3 mb-5">
        <label class="font-semibold w-6rem">Pagos Manuales</label>
        <span class="flex-auto">{{clubSelected.administrativeInformation.manualPaymentEnable ? 'Si' : 'No'}}</span>
      </div>
      <div class="flex align-items-center gap-3 mb-5">
        <label class="font-semibold w-6rem">Vinculado</label>
        <span class="flex-auto">{{clubSelected.administrativeInformation.isExternal ? 'No' : 'Si'}}</span>
      </div>
    </div>

    <!-- Modo edición -->
    <div *ngIf="isEditingClub && clubBeingEdited">
      <div class="flex flex-column gap-3 mb-3">
          <label for="clubName" class="font-semibold">Nombre *</label>
          <input pInputText [(ngModel)]="clubBeingEdited.name"
                 id="clubName" class="w-full" placeholder="Nombre del club" required />
          <small class="p-text-secondary">El nuevo nombre también se aplicará a las vinculaciones del club.</small>
      </div>
      <div class="flex flex-column gap-3 mb-3">
          <label for="email" class="font-semibold">Email *</label>
          <input pInputText [(ngModel)]="clubBeingEdited.contactInformation.email" 
                 id="email" class="w-full" placeholder="Email del club" required />
      </div>
      <div class="flex flex-column gap-3 mb-3">
          <label for="telephone" class="font-semibold">Teléfono</label>
          <input pInputText [(ngModel)]="clubBeingEdited.contactInformation.telephone" 
                 id="telephone" class="w-full" placeholder="Teléfono del club" />
      </div>
      <div class="flex flex-column gap-3 mb-3">
        <label for="representative" class="font-semibold">Representante Legal *</label>
        <input pInputText [(ngModel)]="clubBeingEdited.administrativeInformation.leagalPrincipal" 
               id="representative" class="w-full" placeholder="Nombre del representante legal" required />
      </div>
      <div class="flex align-items-center gap-3 mb-5">
        <label for="manualPayment" class="font-semibold">Habilitar Pagos Manuales</label>
        <p-checkbox [(ngModel)]="clubBeingEdited.administrativeInformation.manualPaymentEnable" 
                    id="manualPayment" [binary]="true" />
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-between align-items-center">
        <div class="p-text-secondary" *ngIf="!isEditingClub">
          <span>Id: {{clubSelected.id}}</span>
        </div>
        <div class="flex gap-2" *ngIf="!isEditingClub">
          <p-button label="Editar" icon="pi pi-pencil" 
                    (onClick)="editClub()" 
                    class="p-button-outlined p-button-sm" />
        </div>
        <div class="flex gap-2" *ngIf="isEditingClub">
          <p-button label="Cancelar" icon="pi pi-times" 
                    (onClick)="cancelEditClub()" 
                    class="p-button-text p-button-sm" />
          <p-button label="Guardar" icon="pi pi-check" 
                    (onClick)="saveClub()" 
                    class="p-button-sm" />
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
